import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import './ConsolaModal.css';

const TIENDAS_DEMO = [
  { nombre: 'Sporting', tipo: 'VTEX', estado: 'Escaneando', items: '18.939', rango: '$10k - $20k' },
  { nombre: 'Dexter', tipo: 'Dabra', estado: 'Sync Talles', items: '1.893', rango: 'ATS Realtime' },
  { nombre: 'Exit', tipo: 'VTEX', estado: 'Activo', items: '4.509', rango: '$0 - $50k' },
  { nombre: 'Woker BySporting', tipo: 'VTEX', estado: 'Escaneando', items: '4.982', rango: 'Calzado $20k-$40k' },
  { nombre: 'Moov', tipo: 'Dabra', estado: 'Sync Talles', items: '1.240', rango: 'ATS Realtime' },
  { nombre: 'Stock Center', tipo: 'Dabra', estado: 'Sync Talles', items: '950', rango: 'ATS Realtime' },
  { nombre: 'Salomon', tipo: 'Shopify', estado: 'Activo', items: '730', rango: 'Products JSON' },
  { nombre: 'Tienda Tate', tipo: 'VTEX', estado: 'Activo', items: '16.529', rango: '$0 - $15k' },
  { nombre: 'Chelsea', tipo: 'VTEX', estado: 'Escaneando', items: '3.985', rango: '$10k - $30k' },
  { nombre: 'Ferreira Sport', tipo: 'VTEX', estado: 'Activo', items: '10.123', rango: '$15k - $35k' },
  { nombre: 'Grid', tipo: 'VTEX', estado: 'Activo', items: '3.848', rango: '$25k - $60k' },
  { nombre: 'Reebok', tipo: 'Shopify', estado: 'Activo', items: '902', rango: 'Products JSON' },
  { nombre: 'Crocs', tipo: 'Shopify', estado: 'Activo', items: '665', rango: 'Products JSON' },
  { nombre: 'Kappa', tipo: 'Shopify', estado: 'Activo', items: '889', rango: 'Products JSON' },
  { nombre: 'Scandinavian', tipo: 'VTEX', estado: 'Activo', items: '1.278', rango: 'Columbia / Nexxt' },
  { nombre: 'Sportline', tipo: 'VTEX', estado: 'Escaneando', items: '2.676', rango: '$15k - $45k' },
  { nombre: 'NewSport', tipo: 'VTEX', estado: 'Activo', items: '9.827', rango: '$5k - $25k' },
  { nombre: 'Fila', tipo: 'VTEX', estado: 'Activo', items: '269', rango: 'Catálogo Oficial' },
  { nombre: '47 Street', tipo: 'VTEX', estado: 'Activo', items: '1.657', rango: 'Moda Femenina' },
  { nombre: 'Bowen', tipo: 'Tiendanube', estado: 'Activo', items: '320', rango: 'Nuvemshop API' },
  { nombre: 'Ricky Sarkany', tipo: 'VTEX', estado: 'Activo', items: '244', rango: 'Calzado & Moda' },
  { nombre: 'Parfumerie', tipo: 'Magento', estado: 'Activo', items: '1.450', rango: 'Fragancias & Sale' },
  { nombre: 'Tommy Hilfiger', tipo: 'VTEX', estado: 'Activo', items: '415', rango: 'Colección' }
];

const EVENTOS_PRODUCTOS_SEED = [
  {
    tag: 'OFERTA 🔥',
    tipo: 'oferta',
    nombre: 'CK EVERYONE EDP 100ML',
    tienda: 'Parfumerie',
    precio: 84000,
    precioAnt: 165165,
    descuento: 49,
    talles: ['100ML'],
    url: 'https://www.parfumerie.com.ar/ck-everyone-edp-100ml-rv148692',
    msg: '💄 Parfumerie | CK Everyone EDP 100ml: $ 84.000 (Antes: $ 165.165) -49% OFF'
  },
  {
    tag: 'TALLES',
    tipo: 'talles',
    nombre: 'Zapatillas DC Court Graffik',
    tienda: 'Exit',
    precio: 111999,
    precioAnt: 159999,
    descuento: 30,
    talles: ['34', '35.5'],
    url: 'https://www.exit.com.ar/zapatillas-mujer-dc-court-graffik-action-sport-1262112034/p',
    msg: '👟 Exit | Zapatillas DC Court Graffik -> Talles con stock: [ 34, 35.5 ]'
  },
  {
    tag: 'OFERTA 🔥',
    tipo: 'oferta',
    nombre: 'Short Under Armour Peak Woven Hombre',
    tienda: 'Dexter',
    precio: 24999,
    precioAnt: 79999,
    descuento: 68,
    talles: ['XS'],
    url: 'https://www.dexter.com.ar/short-entrenamiento-under-armour-peak-woven-hombre/UA1383348-561.html',
    msg: 'Dexter | Short Under Armour Peak Woven: $ 24.999 (Antes: $ 79.999) -68% OFF'
  },
  {
    tag: 'SHOPIFY',
    tipo: 'shopify',
    nombre: 'Zapatillas Salomon Elixir Tour M',
    tienda: 'Salomon',
    precio: 219999,
    precioAnt: 289999,
    descuento: 24,
    talles: ['39', '40', '41', '42', '43'],
    url: 'https://salomonstore.com.ar/products/elixir-tour-m',
    msg: 'Salomon | Elixir Tour M -> Sincronizadas variantes con stock'
  },
  {
    tag: 'TALLES',
    tipo: 'talles',
    nombre: 'Zapatillas Puma Karmen II Mujer',
    tienda: 'Dexter',
    precio: 34999,
    precioAnt: 118999,
    descuento: 70,
    talles: ['37.5'],
    url: 'https://www.dexter.com.ar/zapatillas-puma-karmen-ii-mujer/PU397457-05.html',
    msg: '👟 Dexter | Zapatillas Puma Karmen II -> Talles con stock: [ 37.5 ]'
  },
  {
    tag: 'RADAR 🏆',
    tipo: 'radar',
    nombre: 'Gorra adidas Originals Baseball',
    tienda: 'Chelsea',
    precio: 34999,
    precioAnt: 49999,
    descuento: 30,
    talles: ['Único'],
    url: 'https://www.chelsea.com.ar/gorra-adidas-baseball-moda-kr1658/p',
    msg: 'Nuevo mínimo histórico detectado en Chelsea: Gorra adidas Baseball'
  },
  {
    tag: 'TALLES',
    tipo: 'talles',
    nombre: 'Zuecos Crocs Crocband Infantil',
    tienda: 'Moov',
    precio: 49999,
    precioAnt: 79999,
    descuento: 38,
    talles: ['27', '28', '29', '30'],
    url: 'https://www.moov.com.ar/zuecos-crocs-crocband-para-infantil/CRSC10998-C5P8.html',
    msg: '👕 Moov | Zuecos Crocs Crocband -> Talles con stock: [ 27, 28, 29, 30 ]'
  },
  {
    tag: 'OFERTA 🔥',
    tipo: 'oferta',
    nombre: 'Remera Entrenamiento Nike Zenvy Rib Mujer',
    tienda: 'Dexter',
    precio: 39999,
    precioAnt: 65999,
    descuento: 39,
    talles: ['XS', 'S', 'M'],
    url: 'https://www.dexter.com.ar/remera-entrenamiento-nike-zenvy-rib-mujer/NIFN7467-104.html',
    msg: 'Dexter | Remera Nike Zenvy Rib: $ 39.999 (-39% OFF)'
  },
  {
    tag: 'TALLES',
    tipo: 'talles',
    nombre: 'Buzo Puma Essential Comfort Mujer',
    tienda: 'Sportline',
    precio: 59999,
    precioAnt: 89999,
    descuento: 33,
    talles: ['S', 'M', 'L'],
    url: 'https://www.sportline.com.ar/essential-comfort-480215068238604/p',
    msg: '👟 Sportline | Buzo Puma Essential Comfort -> Talles con stock: [ S, M, L ]'
  },
  {
    tag: 'TIENDANUBE',
    tipo: 'tiendanube',
    nombre: 'Under O T-Shirt x 2',
    tienda: 'Bowen',
    precio: 74900,
    precioAnt: 98000,
    descuento: 24,
    talles: ['S', 'M', 'L', 'XL'],
    url: 'https://www.bowen.com.ar/productos/under-o-t-shirt-x-2-p621701711/?variant=1609011519',
    msg: 'Bowen: Detectada oferta Under O T-Shirt x 2 con talles [ S, M, L, XL ]'
  },
  {
    tag: 'VTEX',
    tipo: 'vtex',
    nombre: 'Zapatillas Puma Pounce Lite 2 Unisex',
    tienda: 'Sporting',
    precio: 89999,
    precioAnt: 129999,
    descuento: 31,
    talles: ['38', '39', '40', '41', '42'],
    url: 'https://www.sporting.com.ar/zapatillas-puma-pounce-lite-2-unisex-31484705-000/p',
    msg: 'Sporting: Recibidos productos con stock en talles activos'
  }
];

function ConsolaModal({ alCerrar, apiBaseUrl }) {
  const [logs, setLogs] = useState([]);
  const [ofertasEncontradas, setOfertasEncontradas] = useState([]);
  const [vistaActiva, setVistaActiva] = useState('stream'); // 'stream' | 'ofertas'
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [pausado, setPausado] = useState(false);
  const [pantallaCompleta, setPantallaCompleta] = useState(false);
  const [filtroTienda, setFiltroTienda] = useState('');
  const [tiendaActivaIdx, setTiendaActivaIdx] = useState(0);
  const [tiempoCiclo, setTiempoCiclo] = useState(420);
  const [statsSys, setStatsSys] = useState({
    cpu: 18,
    ramMb: 418,
    uptime: 14250,
    productosTotal: 1068500,
    tiendasTotal: 99
  });

  const logsEndRef = useRef(null);
  const inputFilterRef = useRef(null);

  // Cargar ofertas reales iniciales desde la API para alimentar la consola interactiva
  useEffect(() => {
    const baseUrl = apiBaseUrl || '/api';
    fetch(`${baseUrl}/productos?limit=40&orden=reciente`)
      .then(res => res.json())
      .then(data => {
        const prods = data.productos || data;
        if (Array.isArray(prods) && prods.length > 0) {
          const formateadas = prods.filter(p => p.url).map(p => ({
            id: p._id || p.sku,
            nombre: p.nombre,
            tienda: p.tienda,
            precio: p.price,
            precioAnt: p.priceSinDescuento || p.UltPrecio || p.price,
            descuento: p.descuento || (p.priceSinDescuento ? Math.round(((p.priceSinDescuento - p.price) / p.priceSinDescuento) * 100) : 0),
            talles: p.talles || [],
            url: p.url
          }));
          setOfertasEncontradas(formateadas);
        }
      })
      .catch(() => {});
  }, [apiBaseUrl]);

  // Inicializar logs base
  useEffect(() => {
    const ahora = new Date().toLocaleTimeString('es-AR');
    const logsIniciales = [
      { time: ahora, tag: 'INIT', tipo: 'info', msg: '⚡ VTEX Monitor Bot v3.0 Pro inicializado en arquitectura distribuida.' },
      { time: ahora, tag: 'CLUSTER', tipo: 'info', msg: '🔗 Conexión a MongoDB (vtexmonitor) establecida. 1.068.500+ registros.' },
      { time: ahora, tag: 'CLUSTER', tipo: 'info', msg: '🌐 91 tiendas VTEX + 3 Grupo Dabra + 5 Shopify + Tiendanube operativas.' },
      { time: ahora, tag: 'TALLES', tipo: 'talles', msg: '👟 Extractor universal de talles activo en tiempo real.' },
      { time: ahora, tag: 'CRON', tipo: 'info', msg: '⏱️ Ciclo automático de escaneo configurado cada 7 minutos.' },
      ...EVENTOS_PRODUCTOS_SEED.slice(0, 4).map(e => ({
        time: ahora,
        tag: e.tag,
        tipo: e.tipo,
        msg: e.msg,
        url: e.url,
        nombre: e.nombre,
        tienda: e.tienda,
        precio: e.precio,
        talles: e.talles
      }))
    ];
    setLogs(logsIniciales);
  }, []);

  // Timer del ciclo
  useEffect(() => {
    const timer = setInterval(() => {
      setTiempoCiclo(prev => (prev > 1 ? prev - 1 : 420));
      setStatsSys(prev => ({
        ...prev,
        cpu: Math.floor(Math.random() * 14) + 12,
        ramMb: Math.min(512, Math.max(380, prev.ramMb + (Math.floor(Math.random() * 5) - 2)))
      }));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Rotación de tienda activa en el panel lateral
  useEffect(() => {
    const storeInterval = setInterval(() => {
      setTiendaActivaIdx(prev => (prev + 1) % TIENDAS_DEMO.length);
    }, 1800);
    return () => clearInterval(storeInterval);
  }, []);

  // Generador continuo de eventos con URL
  useEffect(() => {
    if (pausado) return;

    const interval = setInterval(() => {
      let nuevoLog = null;
      if (ofertasEncontradas.length > 0 && Math.random() < 0.65) {
        const prod = ofertasEncontradas[Math.floor(Math.random() * ofertasEncontradas.length)];
        const esCalzado = /zapatill|botin|zapato|calzado/i.test(prod.nombre || '');
        const iconTalle = esCalzado ? '👟' : '👕';
        const tallesStr = prod.talles && prod.talles.length > 0 ? ` -> ${iconTalle} Talles: [ ${prod.talles.slice(0, 5).join(', ')} ]` : '';
        const tag = prod.descuento >= 35 ? 'OFERTA 🔥' : (prod.talles?.length > 0 ? 'TALLES' : 'VTEX');
        const tipo = prod.descuento >= 35 ? 'oferta' : (prod.talles?.length > 0 ? 'talles' : 'vtex');
        
        nuevoLog = {
          time: new Date().toLocaleTimeString('es-AR'),
          tag,
          tipo,
          msg: `${prod.tienda} | ${prod.nombre}: $ ${(prod.precio || 0).toLocaleString('es-AR')}${prod.descuento > 0 ? ` (-${prod.descuento}% OFF)` : ''}${tallesStr}`,
          url: prod.url,
          nombre: prod.nombre,
          tienda: prod.tienda,
          precio: prod.precio,
          talles: prod.talles
        };
      } else {
        const e = EVENTOS_PRODUCTOS_SEED[Math.floor(Math.random() * EVENTOS_PRODUCTOS_SEED.length)];
        nuevoLog = {
          time: new Date().toLocaleTimeString('es-AR'),
          tag: e.tag,
          tipo: e.tipo,
          msg: e.msg,
          url: e.url,
          nombre: e.nombre,
          tienda: e.tienda,
          precio: e.precio,
          talles: e.talles
        };
      }

      setLogs(prev => {
        const updated = [...prev, nuevoLog];
        return updated.length > 250 ? updated.slice(updated.length - 250) : updated;
      });

      // Si tiene producto válido, sumar a ofertas encontradas
      if (nuevoLog.url) {
        setOfertasEncontradas(prev => {
          if (prev.some(p => p.url === nuevoLog.url)) return prev;
          return [{
            nombre: nuevoLog.nombre,
            tienda: nuevoLog.tienda,
            precio: nuevoLog.precio,
            precioAnt: nuevoLog.precioAnt || nuevoLog.precio,
            descuento: nuevoLog.descuento || 0,
            talles: nuevoLog.talles || [],
            url: nuevoLog.url
          }, ...prev].slice(0, 60);
        });
      }
    }, 1800);

    return () => clearInterval(interval);
  }, [pausado, ofertasEncontradas]);

  // Consulta de logs reales del backend
  useEffect(() => {
    const baseUrl = apiBaseUrl || '/api';
    const fetchRealLogs = async () => {
      try {
        const res = await fetch(`${baseUrl}/consola/logs`);
        if (res.ok) {
          const data = await res.json();
          if (data.ramMb) setStatsSys(prev => ({ ...prev, ramMb: data.ramMb }));
          if (Array.isArray(data.logs) && data.logs.length > 0) {
            const formateados = data.logs.map(l => ({
              time: l.time,
              tag: l.tag,
              tipo: l.tag === 'TALLES' ? 'talles' : l.tag === 'STOCK' ? 'stock' : 'info',
              msg: l.msg
            }));
            setLogs(prev => {
              const existingMsgs = new Set(prev.map(p => p.msg));
              const news = formateados.filter(f => !existingMsgs.has(f.msg));
              return news.length > 0 ? [...prev, ...news].slice(-250) : prev;
            });
          }
        }
      } catch (e) {}
    };

    fetchRealLogs();
    const pollTimer = setInterval(fetchRealLogs, 5000);
    return () => clearInterval(pollTimer);
  }, [apiBaseUrl]);

  // Filtrado de logs
  const logsFiltrados = useMemo(() => {
    if (!filtroTienda) return logs;
    const term = filtroTienda.toLowerCase();
    return logs.filter(l => l.msg.toLowerCase().includes(term) || l.tag.toLowerCase().includes(term));
  }, [logs, filtroTienda]);

  // Lista de elementos interactivos que tienen link para navegar con flechas
  const itemsInteractivos = useMemo(() => {
    if (vistaActiva === 'ofertas') {
      if (!filtroTienda) return ofertasEncontradas;
      const term = filtroTienda.toLowerCase();
      return ofertasEncontradas.filter(o => o.nombre.toLowerCase().includes(term) || o.tienda.toLowerCase().includes(term));
    } else {
      return logsFiltrados.filter(l => Boolean(l.url));
    }
  }, [vistaActiva, ofertasEncontradas, logsFiltrados, filtroTienda]);

  // Ajustar índice de selección cuando cambia la lista
  useEffect(() => {
    if (selectedIdx >= itemsInteractivos.length && itemsInteractivos.length > 0) {
      setSelectedIdx(itemsInteractivos.length - 1);
    }
  }, [itemsInteractivos.length, selectedIdx]);

  const abrirUrl = useCallback((url) => {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  }, []);

  // --- NAVEGACIÓN POR TECLADO (↑, ↓, Enter, Espacio, Esc) ---
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Si el usuario está escribiendo en el buscador de la consola, no interceptar flechas
      if (document.activeElement === inputFilterRef.current) {
        if (e.key === 'Escape') {
          inputFilterRef.current.blur();
        }
        return;
      }

      if (e.key === 'ArrowUp' || e.key === 'k') {
        e.preventDefault();
        setSelectedIdx(prev => {
          const next = Math.max(0, prev - 1);
          const el = document.getElementById(`selectable-item-${next}`);
          if (el) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          return next;
        });
      } else if (e.key === 'ArrowDown' || e.key === 'j') {
        e.preventDefault();
        setSelectedIdx(prev => {
          const maxIdx = Math.max(0, itemsInteractivos.length - 1);
          const next = Math.min(maxIdx, prev + 1);
          const el = document.getElementById(`selectable-item-${next}`);
          if (el) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          return next;
        });
      } else if (e.key === 'Enter') {
        e.preventDefault();
        const item = itemsInteractivos[selectedIdx];
        if (item && item.url) {
          abrirUrl(item.url);
        }
      } else if (e.key === ' ' || e.code === 'Space') {
        e.preventDefault();
        setPausado(prev => !prev);
      } else if (e.key === 'Escape') {
        alCerrar();
      } else if (e.key === 'Tab') {
        e.preventDefault();
        setVistaActiva(prev => (prev === 'stream' ? 'ofertas' : 'stream'));
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [itemsInteractivos, selectedIdx, abrirUrl, alCerrar]);

  // Auto-scroll del stream solo si no está navegando activamente con flechas
  useEffect(() => {
    if (!pausado && vistaActiva === 'stream' && logsEndRef.current && !filtroTienda) {
      logsEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [logs.length, pausado, vistaActiva, filtroTienda]);

  const formatearTiempo = (seg) => {
    const m = Math.floor(seg / 60);
    const s = seg % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };

  const itemSeleccionadoActual = itemsInteractivos[selectedIdx];

  return (
    <div className="consola-modal-overlay" onClick={alCerrar}>
      <div 
        className={`consola-modal-container ${pantallaCompleta ? 'fullscreen' : ''}`}
        onClick={e => e.stopPropagation()}
      >
        {/* Barra superior estilo macOS / Linux Terminal */}
        <div className="consola-titlebar">
          <div className="consola-window-dots">
            <span className="dot dot-close" onClick={alCerrar} title="Cerrar consola (Esc)">✕</span>
            <span className="dot dot-minimize" onClick={() => setPausado(!pausado)} title={pausado ? 'Reanudar' : 'Pausar stream (Espacio)'}>−</span>
            <span className="dot dot-fullscreen" onClick={() => setPantallaCompleta(!pantallaCompleta)} title="Pantalla completa">⤢</span>
          </div>

          <div className="consola-title-text">
            <span className="terminal-icon">⚡</span>
            VTEX Monitor Engine — Blessed Console Simulator [Terminal v3.0]
            <span className="badge-online">● ONLINE</span>
          </div>

          <div className="consola-top-actions">
            <button 
              type="button" 
              className={`btn-consola-action ${pausado ? 'btn-reanudar' : ''}`} 
              onClick={() => setPausado(!pausado)}
              title="Pausar o reanudar el stream (Barra espaciadora)"
            >
              {pausado ? '▶ Reanudar' : '⏸ Pausar'}
            </button>
            <button 
              type="button" 
              className="btn-consola-action" 
              onClick={() => setLogs([])}
              title="Limpiar pantalla"
            >
              🗑️ Limpiar
            </button>
            <button 
              type="button" 
              className="btn-consola-cerrar" 
              onClick={alCerrar}
              title="Cerrar (Esc)"
            >
              ✕
            </button>
          </div>
        </div>

        {/* HUD / Banner de métricas del sistema (Blessed style) */}
        <div className="consola-hud-bar">
          <div className="hud-metric">
            <span className="hud-label">CPU:</span>
            <span className="hud-val hud-green">{statsSys.cpu}%</span>
            <div className="hud-mini-bar">
              <div className="hud-mini-fill" style={{ width: `${statsSys.cpu * 3}%` }}></div>
            </div>
          </div>
          <div className="hud-metric">
            <span className="hud-label">RAM:</span>
            <span className="hud-val hud-cyan">{statsSys.ramMb} MB</span>
          </div>
          <div className="hud-metric">
            <span className="hud-label">TIENDAS:</span>
            <span className="hud-val hud-yellow">{statsSys.tiendasTotal} activas</span>
          </div>
          <div className="hud-metric">
            <span className="hud-label">CATÁLOGO:</span>
            <span className="hud-val hud-magenta">1.068.500+</span>
          </div>
          <div className="hud-metric">
            <span className="hud-label">PRÓXIMO CICLO:</span>
            <span className="hud-val hud-orange">⏱️ {formatearTiempo(tiempoCiclo)}</span>
          </div>
        </div>

        {/* Barra interactiva de Blessed: Guía de Navegación ↑↓ y Enter */}
        <div className="consola-navigation-helper-bar">
          <div className="helper-left">
            <span className="keyboard-pill">↑ / k</span>
            <span className="keyboard-pill">↓ / j</span>
            <span className="helper-text">para navegar</span>
            <span className="helper-separator">|</span>
            <span className="keyboard-pill pill-enter">Enter ↵</span>
            <span className="helper-text">abrir URL del producto</span>
          </div>

          <div className="helper-tabs">
            <button 
              type="button" 
              className={`btn-tab-consola ${vistaActiva === 'stream' ? 'activo' : ''}`}
              onClick={() => setVistaActiva('stream')}
            >
              📜 Terminal Stream
            </button>
            <button 
              type="button" 
              className={`btn-tab-consola ${vistaActiva === 'ofertas' ? 'activo' : ''}`}
              onClick={() => setVistaActiva('ofertas')}
            >
              🏆 Tabla de Ofertas ({ofertasEncontradas.length})
            </button>
          </div>
        </div>

        {/* Cuerpo principal: Split View (Blessed Layout) */}
        <div className="consola-body-split">
          {/* Panel Izquierdo: Estado por Tienda */}
          <div className="consola-stores-panel">
            <div className="panel-header">
              <span>📡 TIENDAS EN MONITOREO</span>
              <span className="panel-badge">{TIENDAS_DEMO.length} de 99</span>
            </div>
            <div className="stores-scroll-list">
              {TIENDAS_DEMO.map((t, idx) => {
                const esActiva = idx === tiendaActivaIdx;
                return (
                  <div key={idx} className={`store-row ${esActiva ? 'store-scanning' : ''}`}>
                    <div className="store-name-col">
                      <span className={`store-status-dot ${esActiva ? 'dot-pulsing' : ''}`}>●</span>
                      <strong>{t.nombre}</strong>
                    </div>
                    <div className="store-rango">{t.rango}</div>
                    <div className="store-meta">
                      <span className="store-tipo">{t.tipo}</span>
                      <span className={`store-estado-pill ${t.estado.toLowerCase().replace(/\s/g, '-')}`}>
                        {esActiva ? '⚡ SCAN' : t.estado}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Panel Derecho: Stream de Terminal O Tabla de Ofertas */}
          <div className="consola-terminal-panel">
            <div className="panel-header terminal-stream-header">
              <span className="header-title-dynamic">
                {vistaActiva === 'stream' 
                  ? '🖥️ LOGS DE EJECUCIÓN (Líneas con 🔗 click o Enter para abrir)' 
                  : '🏆 OFERTAS ENCONTRADAS (Presioná ↑↓ para navegar y Enter para abrir)'}
              </span>
              <input 
                ref={inputFilterRef}
                type="text" 
                placeholder="🔍 Filtrar tienda / nombre..." 
                value={filtroTienda} 
                onChange={e => { setFiltroTienda(e.target.value); setSelectedIdx(0); }}
                className="input-filter-terminal"
              />
            </div>

            {/* VISTA 1: STREAM DE TERMINAL */}
            {vistaActiva === 'stream' && (
              <div className="terminal-screen-content">
                {logsFiltrados.map((log, index) => {
                  let colorClase = 'log-default';
                  if (log.tipo === 'talles') colorClase = 'log-talles';
                  else if (log.tipo === 'oferta') colorClase = 'log-oferta';
                  else if (log.tipo === 'vtex') colorClase = 'log-vtex';
                  else if (log.tipo === 'shopify') colorClase = 'log-shopify';
                  else if (log.tipo === 'stock') colorClase = 'log-stock';
                  else if (log.tipo === 'radar') colorClase = 'log-radar';

                  // Verificar si este log es el seleccionado por teclado
                  const interactivoIdx = itemsInteractivos.indexOf(log);
                  const esSeleccionado = interactivoIdx !== -1 && interactivoIdx === selectedIdx;

                  return (
                    <div 
                      key={index} 
                      id={interactivoIdx !== -1 ? `selectable-item-${interactivoIdx}` : undefined}
                      className={`terminal-log-line ${colorClase} ${log.url ? 'has-link' : ''} ${esSeleccionado ? 'log-line-selected' : ''}`}
                      onClick={() => {
                        if (interactivoIdx !== -1) setSelectedIdx(interactivoIdx);
                        if (log.url) abrirUrl(log.url);
                      }}
                    >
                      <span className="log-time">[{log.time}]</span>
                      <span className={`log-tag tag-${log.tipo}`}>[{log.tag}]</span>
                      
                      {esSeleccionado && <span className="selection-arrow">❯</span>}

                      <span className="log-msg">{log.msg}</span>

                      {log.url && (
                        <span 
                          className={`link-pill-open ${esSeleccionado ? 'pill-focused' : ''}`}
                          onClick={(e) => { e.stopPropagation(); abrirUrl(log.url); }}
                          title="Hacer clic o presionar Enter para abrir en el navegador"
                        >
                          {esSeleccionado ? '↵ ENTER para abrir ↗' : '🔗 Abrir ↗'}
                        </span>
                      )}
                    </div>
                  );
                })}
                <div className="terminal-prompt-line">
                  <span className="prompt-user">root@vtex-monitor:~$</span>
                  <span className="prompt-cursor">▋</span>
                </div>
                <div ref={logsEndRef} />
              </div>
            )}

            {/* VISTA 2: TABLA DE OFERTAS ENCONTRADAS (Blessed tableBox) */}
            {vistaActiva === 'ofertas' && (
              <div className="terminal-screen-content table-view-container">
                <div className="blessed-table-header">
                  <div className="col-idx">#</div>
                  <div className="col-tienda">TIENDA</div>
                  <div className="col-producto">PRODUCTO</div>
                  <div className="col-precio">PRECIO</div>
                  <div className="col-talles">TALLES</div>
                  <div className="col-action">ACCIÓN</div>
                </div>

                <div className="blessed-table-body">
                  {itemsInteractivos.length === 0 ? (
                    <div className="table-empty-notice">
                      No hay ofertas que coincidan con el filtro actual.
                    </div>
                  ) : (
                    itemsInteractivos.map((prod, idx) => {
                      const esSeleccionado = idx === selectedIdx;
                      return (
                        <div 
                          key={idx}
                          id={`selectable-item-${idx}`}
                          className={`blessed-table-row ${esSeleccionado ? 'row-selected' : ''}`}
                          onClick={() => {
                            setSelectedIdx(idx);
                            abrirUrl(prod.url);
                          }}
                        >
                          <div className="col-idx">
                            {esSeleccionado ? <span className="row-arrow">❯</span> : idx + 1}
                          </div>
                          <div className="col-tienda">
                            <span className="tag-tienda">{prod.tienda}</span>
                          </div>
                          <div className="col-producto" title={prod.nombre}>
                            {prod.nombre}
                          </div>
                          <div className="col-precio">
                            <span className="precio-actual">${(prod.precio || 0).toLocaleString('es-AR')}</span>
                            {prod.descuento > 0 && (
                              <span className="badge-desc-tag">-{prod.descuento}%</span>
                            )}
                          </div>
                          <div className="col-talles">
                            {prod.talles && prod.talles.length > 0 ? (
                              <div className="talles-mini-list">
                                {prod.talles.slice(0, 4).map((t, ti) => (
                                  <span key={ti} className="talle-micro-tag">{t}</span>
                                ))}
                                {prod.talles.length > 4 && (
                                  <span className="talle-micro-tag">+{prod.talles.length - 4}</span>
                                )}
                              </div>
                            ) : (
                              <span className="sin-talle-tag">-</span>
                            )}
                          </div>
                          <div className="col-action">
                            <button
                              type="button"
                              className={`btn-row-open ${esSeleccionado ? 'btn-selected-pulse' : ''}`}
                              onClick={(e) => { e.stopPropagation(); abrirUrl(prod.url); }}
                            >
                              {esSeleccionado ? '↵ ENTER ↗' : 'Abrir ↗'}
                            </button>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            )}

            {/* Barra flotante de selección activa actual */}
            {itemSeleccionadoActual && itemSeleccionadoActual.url && (
              <div className="selected-item-bar-bottom" onClick={() => abrirUrl(itemSeleccionadoActual.url)}>
                <span className="selected-item-label">
                  <span className="key-badge">ENTER</span> Seleccionado ({selectedIdx + 1}/{itemsInteractivos.length}):
                </span>
                <span className="selected-item-title">
                  <strong>{itemSeleccionadoActual.tienda}</strong>: {itemSeleccionadoActual.nombre || itemSeleccionadoActual.msg}
                </span>
                <span className="btn-open-direct">Abrir enlace ↗</span>
              </div>
            )}
          </div>
        </div>

        {/* Footer con atajos de teclado y estado de conexión */}
        <div className="consola-footer-bar">
          <div className="footer-shortcuts">
            <span><strong>↑/↓:</strong> Navegar</span>
            <span><strong>ENTER:</strong> Abrir URL</span>
            <span><strong>TAB:</strong> Cambiar Vista</span>
            <span><strong>ESPACIO:</strong> Pausar / Reanudar</span>
            <span><strong>ESC:</strong> Cerrar</span>
          </div>
          <div className="footer-status">
            <span>Sockets Keep-Alive: <strong>100 Conexiones</strong></span>
            <span className="footer-bullet">•</span>
            <span>Worker: <strong>PID 21928</strong></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConsolaModal;
